function lightZoom(selector, options) {
  let settings = {
    zoomPower: 1,
    glassSize: 250,
  };

  const customCursor = 'url(https://cdn.shopify.com/s/files/1/0612/7173/6365/files/icon-zoom.svg?v=1731489933), auto';

  // Merge user options with default settings
  Object.assign(settings, options);

  let halfSize = settings.glassSize / 2;
  let zoomPower = settings.zoomPower;

  // Create glass element
  let glass = document.createElement('div');
  glass.id = 'glass';
  document.body.appendChild(glass);
  glass.style.width = settings.glassSize + 'px';
  glass.style.height = settings.glassSize + 'px';
  glass.style.position = 'absolute';
  glass.style.borderRadius = '50%';
  glass.style.pointerEvents = 'none';
  glass.style.display = 'none';

  let obj = document.querySelector(selector);
  let magnifying = false;

  // Show custom cursor only on hover
  obj.addEventListener('mouseenter', () => {
    if (!magnifying) {
      document.body.style.cursor = customCursor;  // Show custom cursor when hovering the image
    }
  });

  // Hide custom cursor on leave
  obj.addEventListener('mouseleave', () => {
    document.body.style.cursor = 'default';  // Reset cursor when leaving the image
    if (magnifying) {
      magnifying = false;
      glass.style.display = 'none';
    }
  });

  // Toggle zoom effect on click
  obj.addEventListener('click', function (event) {
    event.stopPropagation();
    magnifying = !magnifying;

    if (magnifying) {
      glass.style.display = 'block';
      document.body.style.cursor = 'none'; // Hide the custom cursor during zoom
      handleMouseMove(event);
    } else {
      glass.style.display = 'none';
      document.body.style.cursor = customCursor; // Show the custom cursor when zoom stops
    }
  });

  // Move the magnifying glass on mouse move
  obj.addEventListener('mousemove', function (event) {
    if (magnifying) {
      handleMouseMove(event);
    }
  });

  function handleMouseMove(event) {
    let mx = event.pageX;
    let my = event.pageY;
    let bounding = obj.getBoundingClientRect();
    let w = bounding.width;
    let h = bounding.height;
    let ol = bounding.left;
    let ot = bounding.top;

    const src = obj.src;
    const url = new URL(src);
    url.searchParams.set('width', '1600');

    let cx = ((mx - ol) / w) * 100;
    let cy = ((my - ot) / h) * 100;

    mx -= halfSize;
    my -= halfSize;

    glass.style.top = my + 'px';
    glass.style.left = mx + 'px';
    glass.style.backgroundImage = "url('" + url.href + "')";
    glass.style.backgroundSize = w * zoomPower + 'px ' + h * zoomPower + 'px';
    glass.style.backgroundPosition = `${cx}% ${cy}%`;
    glass.style.display = 'block';
  }

  // Hide zoom when clicking outside the image
  document.addEventListener('click', function (event) {
    if (!obj.contains(event.target)) {
      magnifying = false;
      glass.style.display = 'none';
      document.body.style.cursor = 'default';  // Reset the cursor
    }
  });

  return obj;
}

function isDesktopDevice() {
  return window.matchMedia('(min-width: 1024px)').matches && !('ontouchstart' in window); // Check for non-touch devices with 1024px or larger screens
}

function addZoomEffect() {
  if (!isDesktopDevice()) return; // Exit if not on desktop
  
  const imageSelectors = document.querySelectorAll('.image-selector');
  imageSelectors.forEach((image) => {
    if (image.classList.contains('image-selector-applied')) return;
    const newIdentifier = Math.floor(Math.random() * 1000000);
    image.classList.add(`image-selector-${newIdentifier}`, 'image-selector-applied');

    lightZoom(`.image-selector-${newIdentifier}`, {
      zoomPower: 2.6,
      glassSize: 325,
    });
  });
}

window.addEventListener('load', () => {
  addZoomEffect();
});

window.addEventListener('pdp:updated_selected_color', () => {
  addZoomEffect();
});

window.addEventListener('pdp:updated_selected_material', () => {
  addZoomEffect();
});
